/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as SignedOutRouteImport } from './routes/signed-out'
import { Route as AppIndexRouteImport } from './routes/_app.index'
import { Route as AppFilesRouteImport } from './routes/_app.files'
import { Route as AppHealthRouteImport } from './routes/_app.health'
import { Route as AuthCallbackRouteImport } from './routes/auth.callback'
import { Route as AppAccountPreferencesRouteImport } from './routes/_app.account.preferences'
import { Route as AppAccountProfileRouteImport } from './routes/_app.account.profile'
import { Route as AppAdminOrganizationRouteImport } from './routes/_app.admin.organization'
import { Route as AppAdminUsersRouteImport } from './routes/_app.admin.users'
import { Route as AppDevUiRouteImport } from './routes/_app.dev.ui'
import { Route as AppLabsStreamRouteImport } from './routes/_app.labs.stream'
import { Route as AppWWorkspaceRouteImport } from './routes/_app.w.$workspace'
import { Route as AppWWorkspaceIndexRouteImport } from './routes/_app.w.$workspace.index'
import { Route as AppWWorkspaceApplyRouteImport } from './routes/_app.w.$workspace.apply'
import { Route as AppWWorkspaceEnvironmentsRouteImport } from './routes/_app.w.$workspace.environments'
import { Route as AppWWorkspaceScopesRouteImport } from './routes/_app.w.$workspace.scopes'
import { Route as AppWWorkspaceSpecsRouteImport } from './routes/_app.w.$workspace.specs'
import { Route as AppWWorkspacePProjectChatRouteImport } from './routes/_app.w.$workspace.p.$project.chat'
import { Route as AppWWorkspaceSKindNameRouteImport } from './routes/_app.w.$workspace.s.$kind.$name'
import { Route as AppWWorkspacePProjectKindNameRouteImport } from './routes/_app.w.$workspace.p.$project.$kind.$name'
import { Route as AppWWorkspacePProjectRunsIndexRouteImport } from './routes/_app.w.$workspace.p.$project.runs.index'
import { Route as AppWWorkspacePProjectRunsRunRouteImport } from './routes/_app.w.$workspace.p.$project.runs.$run'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const SignedOutRoute = SignedOutRouteImport.update({
  id: '/signed-out',
  path: '/signed-out',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppFilesRoute = AppFilesRouteImport.update({
  id: '/files',
  path: '/files',
  getParentRoute: () => AppRoute,
} as any)
const AppHealthRoute = AppHealthRouteImport.update({
  id: '/health',
  path: '/health',
  getParentRoute: () => AppRoute,
} as any)
const AuthCallbackRoute = AuthCallbackRouteImport.update({
  id: '/auth/callback',
  path: '/auth/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const AppAccountPreferencesRoute = AppAccountPreferencesRouteImport.update({
  id: '/account/preferences',
  path: '/account/preferences',
  getParentRoute: () => AppRoute,
} as any)
const AppAccountProfileRoute = AppAccountProfileRouteImport.update({
  id: '/account/profile',
  path: '/account/profile',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminOrganizationRoute = AppAdminOrganizationRouteImport.update({
  id: '/admin/organization',
  path: '/admin/organization',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminUsersRoute = AppAdminUsersRouteImport.update({
  id: '/admin/users',
  path: '/admin/users',
  getParentRoute: () => AppRoute,
} as any)
const AppDevUiRoute = AppDevUiRouteImport.update({
  id: '/dev/ui',
  path: '/dev/ui',
  getParentRoute: () => AppRoute,
} as any)
const AppLabsStreamRoute = AppLabsStreamRouteImport.update({
  id: '/labs/stream',
  path: '/labs/stream',
  getParentRoute: () => AppRoute,
} as any)
const AppWWorkspaceRoute = AppWWorkspaceRouteImport.update({
  id: '/w/$workspace',
  path: '/w/$workspace',
  getParentRoute: () => AppRoute,
} as any)
const AppWWorkspaceIndexRoute = AppWWorkspaceIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppWWorkspaceRoute,
} as any)
const AppWWorkspaceApplyRoute = AppWWorkspaceApplyRouteImport.update({
  id: '/apply',
  path: '/apply',
  getParentRoute: () => AppWWorkspaceRoute,
} as any)
const AppWWorkspaceEnvironmentsRoute =
  AppWWorkspaceEnvironmentsRouteImport.update({
    id: '/environments',
    path: '/environments',
    getParentRoute: () => AppWWorkspaceRoute,
  } as any)
const AppWWorkspaceScopesRoute = AppWWorkspaceScopesRouteImport.update({
  id: '/scopes',
  path: '/scopes',
  getParentRoute: () => AppWWorkspaceRoute,
} as any)
const AppWWorkspaceSpecsRoute = AppWWorkspaceSpecsRouteImport.update({
  id: '/specs',
  path: '/specs',
  getParentRoute: () => AppWWorkspaceRoute,
} as any)
const AppWWorkspacePProjectChatRoute =
  AppWWorkspacePProjectChatRouteImport.update({
    id: '/p/$project/chat',
    path: '/p/$project/chat',
    getParentRoute: () => AppWWorkspaceRoute,
  } as any)
const AppWWorkspaceSKindNameRoute = AppWWorkspaceSKindNameRouteImport.update({
  id: '/s/$kind/$name',
  path: '/s/$kind/$name',
  getParentRoute: () => AppWWorkspaceRoute,
} as any)
const AppWWorkspacePProjectKindNameRoute =
  AppWWorkspacePProjectKindNameRouteImport.update({
    id: '/p/$project/$kind/$name',
    path: '/p/$project/$kind/$name',
    getParentRoute: () => AppWWorkspaceRoute,
  } as any)
const AppWWorkspacePProjectRunsIndexRoute =
  AppWWorkspacePProjectRunsIndexRouteImport.update({
    id: '/p/$project/runs/',
    path: '/p/$project/runs/',
    getParentRoute: () => AppWWorkspaceRoute,
  } as any)
const AppWWorkspacePProjectRunsRunRoute =
  AppWWorkspacePProjectRunsRunRouteImport.update({
    id: '/p/$project/runs/$run',
    path: '/p/$project/runs/$run',
    getParentRoute: () => AppWWorkspaceRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/signed-out': typeof SignedOutRoute
  '/files': typeof AppFilesRoute
  '/health': typeof AppHealthRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/account/preferences': typeof AppAccountPreferencesRoute
  '/account/profile': typeof AppAccountProfileRoute
  '/admin/organization': typeof AppAdminOrganizationRoute
  '/admin/users': typeof AppAdminUsersRoute
  '/dev/ui': typeof AppDevUiRoute
  '/labs/stream': typeof AppLabsStreamRoute
  '/w/$workspace': typeof AppWWorkspaceRouteWithChildren
  '/w/$workspace/apply': typeof AppWWorkspaceApplyRoute
  '/w/$workspace/environments': typeof AppWWorkspaceEnvironmentsRoute
  '/w/$workspace/scopes': typeof AppWWorkspaceScopesRoute
  '/w/$workspace/specs': typeof AppWWorkspaceSpecsRoute
  '/w/$workspace/': typeof AppWWorkspaceIndexRoute
  '/w/$workspace/p/$project/chat': typeof AppWWorkspacePProjectChatRoute
  '/w/$workspace/s/$kind/$name': typeof AppWWorkspaceSKindNameRoute
  '/w/$workspace/p/$project/$kind/$name': typeof AppWWorkspacePProjectKindNameRoute
  '/w/$workspace/p/$project/runs/$run': typeof AppWWorkspacePProjectRunsRunRoute
  '/w/$workspace/p/$project/runs/': typeof AppWWorkspacePProjectRunsIndexRoute
}
export interface FileRoutesByTo {
  '/signed-out': typeof SignedOutRoute
  '/files': typeof AppFilesRoute
  '/health': typeof AppHealthRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/': typeof AppIndexRoute
  '/account/preferences': typeof AppAccountPreferencesRoute
  '/account/profile': typeof AppAccountProfileRoute
  '/admin/organization': typeof AppAdminOrganizationRoute
  '/admin/users': typeof AppAdminUsersRoute
  '/dev/ui': typeof AppDevUiRoute
  '/labs/stream': typeof AppLabsStreamRoute
  '/w/$workspace/apply': typeof AppWWorkspaceApplyRoute
  '/w/$workspace/environments': typeof AppWWorkspaceEnvironmentsRoute
  '/w/$workspace/scopes': typeof AppWWorkspaceScopesRoute
  '/w/$workspace/specs': typeof AppWWorkspaceSpecsRoute
  '/w/$workspace': typeof AppWWorkspaceIndexRoute
  '/w/$workspace/p/$project/chat': typeof AppWWorkspacePProjectChatRoute
  '/w/$workspace/s/$kind/$name': typeof AppWWorkspaceSKindNameRoute
  '/w/$workspace/p/$project/$kind/$name': typeof AppWWorkspacePProjectKindNameRoute
  '/w/$workspace/p/$project/runs/$run': typeof AppWWorkspacePProjectRunsRunRoute
  '/w/$workspace/p/$project/runs': typeof AppWWorkspacePProjectRunsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/signed-out': typeof SignedOutRoute
  '/_app/files': typeof AppFilesRoute
  '/_app/health': typeof AppHealthRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/_app/': typeof AppIndexRoute
  '/_app/account/preferences': typeof AppAccountPreferencesRoute
  '/_app/account/profile': typeof AppAccountProfileRoute
  '/_app/admin/organization': typeof AppAdminOrganizationRoute
  '/_app/admin/users': typeof AppAdminUsersRoute
  '/_app/dev/ui': typeof AppDevUiRoute
  '/_app/labs/stream': typeof AppLabsStreamRoute
  '/_app/w/$workspace': typeof AppWWorkspaceRouteWithChildren
  '/_app/w/$workspace/apply': typeof AppWWorkspaceApplyRoute
  '/_app/w/$workspace/environments': typeof AppWWorkspaceEnvironmentsRoute
  '/_app/w/$workspace/scopes': typeof AppWWorkspaceScopesRoute
  '/_app/w/$workspace/specs': typeof AppWWorkspaceSpecsRoute
  '/_app/w/$workspace/': typeof AppWWorkspaceIndexRoute
  '/_app/w/$workspace/p/$project/chat': typeof AppWWorkspacePProjectChatRoute
  '/_app/w/$workspace/s/$kind/$name': typeof AppWWorkspaceSKindNameRoute
  '/_app/w/$workspace/p/$project/$kind/$name': typeof AppWWorkspacePProjectKindNameRoute
  '/_app/w/$workspace/p/$project/runs/$run': typeof AppWWorkspacePProjectRunsRunRoute
  '/_app/w/$workspace/p/$project/runs/': typeof AppWWorkspacePProjectRunsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/signed-out'
    | '/files'
    | '/health'
    | '/auth/callback'
    | '/account/preferences'
    | '/account/profile'
    | '/admin/organization'
    | '/admin/users'
    | '/dev/ui'
    | '/labs/stream'
    | '/w/$workspace'
    | '/w/$workspace/apply'
    | '/w/$workspace/environments'
    | '/w/$workspace/scopes'
    | '/w/$workspace/specs'
    | '/w/$workspace/'
    | '/w/$workspace/p/$project/chat'
    | '/w/$workspace/s/$kind/$name'
    | '/w/$workspace/p/$project/$kind/$name'
    | '/w/$workspace/p/$project/runs/$run'
    | '/w/$workspace/p/$project/runs/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/signed-out'
    | '/files'
    | '/health'
    | '/auth/callback'
    | '/'
    | '/account/preferences'
    | '/account/profile'
    | '/admin/organization'
    | '/admin/users'
    | '/dev/ui'
    | '/labs/stream'
    | '/w/$workspace/apply'
    | '/w/$workspace/environments'
    | '/w/$workspace/scopes'
    | '/w/$workspace/specs'
    | '/w/$workspace'
    | '/w/$workspace/p/$project/chat'
    | '/w/$workspace/s/$kind/$name'
    | '/w/$workspace/p/$project/$kind/$name'
    | '/w/$workspace/p/$project/runs/$run'
    | '/w/$workspace/p/$project/runs'
  id:
    | '__root__'
    | '/_app'
    | '/signed-out'
    | '/_app/files'
    | '/_app/health'
    | '/auth/callback'
    | '/_app/'
    | '/_app/account/preferences'
    | '/_app/account/profile'
    | '/_app/admin/organization'
    | '/_app/admin/users'
    | '/_app/dev/ui'
    | '/_app/labs/stream'
    | '/_app/w/$workspace'
    | '/_app/w/$workspace/apply'
    | '/_app/w/$workspace/environments'
    | '/_app/w/$workspace/scopes'
    | '/_app/w/$workspace/specs'
    | '/_app/w/$workspace/'
    | '/_app/w/$workspace/p/$project/chat'
    | '/_app/w/$workspace/s/$kind/$name'
    | '/_app/w/$workspace/p/$project/$kind/$name'
    | '/_app/w/$workspace/p/$project/runs/$run'
    | '/_app/w/$workspace/p/$project/runs/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  SignedOutRoute: typeof SignedOutRoute
  AuthCallbackRoute: typeof AuthCallbackRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signed-out': {
      id: '/signed-out'
      path: '/signed-out'
      fullPath: '/signed-out'
      preLoaderRoute: typeof SignedOutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/files': {
      id: '/_app/files'
      path: '/files'
      fullPath: '/files'
      preLoaderRoute: typeof AppFilesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/health': {
      id: '/_app/health'
      path: '/health'
      fullPath: '/health'
      preLoaderRoute: typeof AppHealthRouteImport
      parentRoute: typeof AppRoute
    }
    '/auth/callback': {
      id: '/auth/callback'
      path: '/auth/callback'
      fullPath: '/auth/callback'
      preLoaderRoute: typeof AuthCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/account/preferences': {
      id: '/_app/account/preferences'
      path: '/account/preferences'
      fullPath: '/account/preferences'
      preLoaderRoute: typeof AppAccountPreferencesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/account/profile': {
      id: '/_app/account/profile'
      path: '/account/profile'
      fullPath: '/account/profile'
      preLoaderRoute: typeof AppAccountProfileRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin/organization': {
      id: '/_app/admin/organization'
      path: '/admin/organization'
      fullPath: '/admin/organization'
      preLoaderRoute: typeof AppAdminOrganizationRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin/users': {
      id: '/_app/admin/users'
      path: '/admin/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AppAdminUsersRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/dev/ui': {
      id: '/_app/dev/ui'
      path: '/dev/ui'
      fullPath: '/dev/ui'
      preLoaderRoute: typeof AppDevUiRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/labs/stream': {
      id: '/_app/labs/stream'
      path: '/labs/stream'
      fullPath: '/labs/stream'
      preLoaderRoute: typeof AppLabsStreamRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/w/$workspace': {
      id: '/_app/w/$workspace'
      path: '/w/$workspace'
      fullPath: '/w/$workspace'
      preLoaderRoute: typeof AppWWorkspaceRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/w/$workspace/': {
      id: '/_app/w/$workspace/'
      path: '/'
      fullPath: '/w/$workspace/'
      preLoaderRoute: typeof AppWWorkspaceIndexRouteImport
      parentRoute: typeof AppWWorkspaceRoute
    }
    '/_app/w/$workspace/apply': {
      id: '/_app/w/$workspace/apply'
      path: '/apply'
      fullPath: '/w/$workspace/apply'
      preLoaderRoute: typeof AppWWorkspaceApplyRouteImport
      parentRoute: typeof AppWWorkspaceRoute
    }
    '/_app/w/$workspace/environments': {
      id: '/_app/w/$workspace/environments'
      path: '/environments'
      fullPath: '/w/$workspace/environments'
      preLoaderRoute: typeof AppWWorkspaceEnvironmentsRouteImport
      parentRoute: typeof AppWWorkspaceRoute
    }
    '/_app/w/$workspace/scopes': {
      id: '/_app/w/$workspace/scopes'
      path: '/scopes'
      fullPath: '/w/$workspace/scopes'
      preLoaderRoute: typeof AppWWorkspaceScopesRouteImport
      parentRoute: typeof AppWWorkspaceRoute
    }
    '/_app/w/$workspace/specs': {
      id: '/_app/w/$workspace/specs'
      path: '/specs'
      fullPath: '/w/$workspace/specs'
      preLoaderRoute: typeof AppWWorkspaceSpecsRouteImport
      parentRoute: typeof AppWWorkspaceRoute
    }
    '/_app/w/$workspace/p/$project/chat': {
      id: '/_app/w/$workspace/p/$project/chat'
      path: '/p/$project/chat'
      fullPath: '/w/$workspace/p/$project/chat'
      preLoaderRoute: typeof AppWWorkspacePProjectChatRouteImport
      parentRoute: typeof AppWWorkspaceRoute
    }
    '/_app/w/$workspace/s/$kind/$name': {
      id: '/_app/w/$workspace/s/$kind/$name'
      path: '/s/$kind/$name'
      fullPath: '/w/$workspace/s/$kind/$name'
      preLoaderRoute: typeof AppWWorkspaceSKindNameRouteImport
      parentRoute: typeof AppWWorkspaceRoute
    }
    '/_app/w/$workspace/p/$project/$kind/$name': {
      id: '/_app/w/$workspace/p/$project/$kind/$name'
      path: '/p/$project/$kind/$name'
      fullPath: '/w/$workspace/p/$project/$kind/$name'
      preLoaderRoute: typeof AppWWorkspacePProjectKindNameRouteImport
      parentRoute: typeof AppWWorkspaceRoute
    }
    '/_app/w/$workspace/p/$project/runs/': {
      id: '/_app/w/$workspace/p/$project/runs/'
      path: '/p/$project/runs'
      fullPath: '/w/$workspace/p/$project/runs/'
      preLoaderRoute: typeof AppWWorkspacePProjectRunsIndexRouteImport
      parentRoute: typeof AppWWorkspaceRoute
    }
    '/_app/w/$workspace/p/$project/runs/$run': {
      id: '/_app/w/$workspace/p/$project/runs/$run'
      path: '/p/$project/runs/$run'
      fullPath: '/w/$workspace/p/$project/runs/$run'
      preLoaderRoute: typeof AppWWorkspacePProjectRunsRunRouteImport
      parentRoute: typeof AppWWorkspaceRoute
    }
  }
}

interface AppWWorkspaceRouteChildren {
  AppWWorkspaceApplyRoute: typeof AppWWorkspaceApplyRoute
  AppWWorkspaceEnvironmentsRoute: typeof AppWWorkspaceEnvironmentsRoute
  AppWWorkspaceScopesRoute: typeof AppWWorkspaceScopesRoute
  AppWWorkspaceSpecsRoute: typeof AppWWorkspaceSpecsRoute
  AppWWorkspaceIndexRoute: typeof AppWWorkspaceIndexRoute
  AppWWorkspacePProjectChatRoute: typeof AppWWorkspacePProjectChatRoute
  AppWWorkspaceSKindNameRoute: typeof AppWWorkspaceSKindNameRoute
  AppWWorkspacePProjectKindNameRoute: typeof AppWWorkspacePProjectKindNameRoute
  AppWWorkspacePProjectRunsRunRoute: typeof AppWWorkspacePProjectRunsRunRoute
  AppWWorkspacePProjectRunsIndexRoute: typeof AppWWorkspacePProjectRunsIndexRoute
}

const AppWWorkspaceRouteChildren: AppWWorkspaceRouteChildren = {
  AppWWorkspaceApplyRoute: AppWWorkspaceApplyRoute,
  AppWWorkspaceEnvironmentsRoute: AppWWorkspaceEnvironmentsRoute,
  AppWWorkspaceScopesRoute: AppWWorkspaceScopesRoute,
  AppWWorkspaceSpecsRoute: AppWWorkspaceSpecsRoute,
  AppWWorkspaceIndexRoute: AppWWorkspaceIndexRoute,
  AppWWorkspacePProjectChatRoute: AppWWorkspacePProjectChatRoute,
  AppWWorkspaceSKindNameRoute: AppWWorkspaceSKindNameRoute,
  AppWWorkspacePProjectKindNameRoute: AppWWorkspacePProjectKindNameRoute,
  AppWWorkspacePProjectRunsRunRoute: AppWWorkspacePProjectRunsRunRoute,
  AppWWorkspacePProjectRunsIndexRoute: AppWWorkspacePProjectRunsIndexRoute,
}

const AppWWorkspaceRouteWithChildren = AppWWorkspaceRoute._addFileChildren(
  AppWWorkspaceRouteChildren,
)

interface AppRouteChildren {
  AppFilesRoute: typeof AppFilesRoute
  AppHealthRoute: typeof AppHealthRoute
  AppIndexRoute: typeof AppIndexRoute
  AppAccountPreferencesRoute: typeof AppAccountPreferencesRoute
  AppAccountProfileRoute: typeof AppAccountProfileRoute
  AppAdminOrganizationRoute: typeof AppAdminOrganizationRoute
  AppAdminUsersRoute: typeof AppAdminUsersRoute
  AppDevUiRoute: typeof AppDevUiRoute
  AppLabsStreamRoute: typeof AppLabsStreamRoute
  AppWWorkspaceRoute: typeof AppWWorkspaceRouteWithChildren
}

const AppRouteChildren: AppRouteChildren = {
  AppFilesRoute: AppFilesRoute,
  AppHealthRoute: AppHealthRoute,
  AppIndexRoute: AppIndexRoute,
  AppAccountPreferencesRoute: AppAccountPreferencesRoute,
  AppAccountProfileRoute: AppAccountProfileRoute,
  AppAdminOrganizationRoute: AppAdminOrganizationRoute,
  AppAdminUsersRoute: AppAdminUsersRoute,
  AppDevUiRoute: AppDevUiRoute,
  AppLabsStreamRoute: AppLabsStreamRoute,
  AppWWorkspaceRoute: AppWWorkspaceRouteWithChildren,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  SignedOutRoute: SignedOutRoute,
  AuthCallbackRoute: AuthCallbackRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
